module.exports = __webpack_public_path__ + "img/47.e3108fde.jpg";